'use strict';

exports.__esModule = true;
exports.add = add;
exports.cancel = cancel;
exports.remove = remove;
exports.removeRange = removeRange;
exports.update = update;

var _actionTypes = require('./action-types');

var actions = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function add(id, state, progress, tags, xhr) {
  return {
    type: actions.ADD_AJAX,
    id: id,
    state: state,
    progress: progress,
    tags: tags,
    xhr: xhr
  };
}
function cancel(id) {
  return {
    type: actions.CANCEL_AJAX,
    id: id
  };
}
function remove(id) {
  return {
    type: actions.REMOVE_AJAX,
    id: id
  };
}
function removeRange(idList) {
  return {
    type: actions.REMOVE_AJAX,
    idList: idList
  };
}
function update(id, state, progress) {
  return {
    type: actions.UPDATE_AJAX_PROGRESS,
    id: id,
    state: state,
    progress: progress
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/data-pipeline/lib/ajax/actions.js
 ** module id = 64
 ** module chunks = 0
 **/